var _style, _path, _path2, _path3, _path4, _circle, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st2{fill:#4a555f}.st3{fill:#ffd452}.st4{fill:#f58e6f}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M509.485 379.127c-6.304-13.998-22.324-20.289-36.478-14.324L344.83 418.862c-19.939 8.41-37.303 11.988-53.685 10.693a27.06 27.06 0 0 0 1.254-.747c8.03-5.068 12.823-13.761 12.823-23.256a27.42 27.42 0 0 0-14.781-24.382l-92.056-48.03h-87.237v104.102h12.374l123.813 53.53a119.196 119.196 0 0 0 47.321 9.802 119.21 119.21 0 0 0 52.164-12.029l149.363-72.67c13.732-6.682 19.576-22.823 13.302-36.748zm-16.178 30.838-149.363 72.67a112.548 112.548 0 0 1-94 2.103L124.883 430.67h-7.162v-90.956h79.051l90.628 47.285a20.861 20.861 0 0 1 11.249 18.553c0 7.226-3.648 13.842-9.757 17.698-5.232 3.302-11.507 4.104-17.302 2.316a77.897 77.897 0 0 1-1.121-.382 21.662 21.662 0 0 1-1.75-.74l-78.137-37.239-2.829 5.933 60.82 28.986c6.085 3.593 12.053 6.392 17.894 8.52 1.75.785 3.55 1.38 5.377 1.783 29.337 8.779 55.21 1.066 75.54-7.508l128.178-54.059c10.827-4.572 23.1.249 27.932 10.967 4.801 10.663.327 23.021-10.187 28.138z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M495.954 385.224c-2.212-4.907-6.959-7.803-11.99-7.803-1.727 0-3.485.341-5.187 1.059l-128.178 54.059c-21.765 9.18-39.885 12.606-55.031 12.606-23.795 0-40.24-8.459-51.917-16.347l-59.456-28.194 9.945-20.865 78.137 37.239a12.691 12.691 0 0 0 5.476 1.263c2.327 0 4.634-.665 6.724-1.985 3.751-2.366 5.902-6.268 5.902-10.703 0-4.732-2.607-9.032-6.803-11.221l-88.832-46.348h-68.342v75.128l-.623-.031.623.27 126.822 53.797a104.347 104.347 0 0 0 41.432 8.584c15.64 0 31.254-3.519 45.668-10.531l149.363-72.67a13.153 13.153 0 0 0 6.267-17.307z",
    style: {
      fill: "#dfdfdf"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0 291.736v187.658h117.721V291.736H0zm111.148 181.085H6.573V298.309h104.575v174.512z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M14.844 306.579h88.035v157.972H14.844z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M42.319 317.665c-10.934 0-19.829 8.896-19.829 19.83 0 10.934 8.895 19.829 19.829 19.829 10.934 0 19.829-8.895 19.829-19.829-.001-10.934-8.896-19.83-19.829-19.83zm0 33.085c-7.309 0-13.255-5.946-13.255-13.255 0-7.309 5.946-13.256 13.255-13.256s13.255 5.947 13.255 13.256c0 7.308-5.946 13.255-13.255 13.255z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 42.319,
    cy: 337.494,
    r: 4.986
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.197 93.033v190.38h42.068V93.033H61.197zm35.495 183.806H67.771V99.606h28.922v177.233z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M75.438 107.274h13.584V269.17H75.438z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M125.812 86.153v238.67h42.066V86.153h-42.066zm35.493 232.097h-28.92V92.726h28.92V318.25z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M140.052 100.394h13.584v210.187h-13.584z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M190.402 134.203v190.62h9.074l33.016 17.232V134.203h-42.09zm35.517 197.006L201.09 318.25h-4.115V140.776h28.944v190.433z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M204.645 148.444v163.011l13.606 7.102V148.444z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M255.017 112.993v240.815l42.09 21.966V112.993h-42.09zm35.516 251.937-28.944-15.106V119.566h28.944V364.93z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M269.257 127.234v217.941l13.609 7.103V127.234z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M319.631 106.486V418.4l4.279-1.358c1.451-.46 14.387-4.584 21.865-7.73l15.945-6.717v-296.11h-42.089zm35.516 291.746-11.922 5.023c-4.502 1.893-11.625 4.354-17.021 6.135V113.059h28.944v285.173z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M333.872 120.728v277.916c2.366-.857 4.589-1.703 6.367-2.451l7.239-3.05V120.728h-13.606z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M384.243 150.964v242.573l42.092-17.761V150.964h-42.092zm35.519 220.451-28.946 12.213V157.537h28.946v213.878z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M398.485 165.205v206.864l13.607-5.742V165.205z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M448.857 106.486v259.989l23.592-10.1c4.709-1.807 9.836-2.452 14.867-1.926l3.631.382V106.486h-42.09zm35.517 241.215a38.503 38.503 0 0 0-14.394 2.584l-14.55 6.228V113.059h28.943v234.642z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M463.1 120.728v224.16l3.86-1.653.387-.157a45.875 45.875 0 0 1 9.359-2.495V120.728H463.1z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m431.556 93.613-10.996 39.028h-30.711l-19.54-54.881h-70.383l-5.753 11.229h-43.376l-15.446 21.883h-39.653l-32.692-66.799H123.07l-21.833 29.063H62.964L19.381 123.82l4.986 4.285 41.614-48.396h38.539l21.833-29.063h32.553l32.692 66.799h47.159l15.446-21.883h43.988l5.754-11.229h61.725l19.54 54.881h40.327l10.995-39.028h66.207v-6.573zM204.644 31.959h247.5v6.573h-247.5z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m418 11.425-3.324 5.67 30.967 18.15-30.967 18.151 3.324 5.67 40.644-23.821z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarket);
export default __webpack_public_path__ + "static/media/market.d4a5e6f42bfc5e46f49f76fe7309c9fe.svg";
export { ForwardRef as ReactComponent };